import React from 'react';
import { RichText } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleText}
 */

const ModuleText = ({
    body,
    heading
}) => {

    return (
        <div className='layout-container layout-site-outer-padding py-40'>
            <div className='col-wrapper flex flex-col gap-y-16 md:flex-row'>
                {heading && (
                    <h3 className='type-style-4 text-text-primary col-padding md:w-6/12'>
                        {heading}
                    </h3>
                )}
                {!heading && (
                    <div className='md:w-6/12 col-padding' />
                )}
                <RichText
                    className='bg-white rich-text text-module col-padding text-text-secondary md:w-6/12'
                    {...body} />
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ModuleText;
